<style lang="sass" rel="stylesheet/sass">
@import ~bi/utilities
@import ~bi/brand/variables
$cta_has_btnRound: true !important
$cta_has_btnRound_S: true !important
@import ../Cta/sass/btnRound
@import sass/scrollLock
@import sass/variables
@import sass/common
@import sass/table
</style>

<template lang="html">
    <div class="g_popin" :class="{ g_popinOpened: isOpen, g_popinSlide: isSlide }" role="alertdialog">
        <div class="g_popinOverlay"/>
        <div class="g_popinFixed">
            <div class="g_popinRestrict g_light">
                <template v-if="isOpen">
                    <Cta
                        ref="close"
                        class="g_btnRoundS g_btnClose"
                        type="button"
                        fontIcon="fn_close"
                        @click="close"
                        :content="closeLabel"
                        :aria-label="closeLabel"/>
                    <div class="g_popinContent">
                        <slot/>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import { getHtml } from 'library/src/utils/dom'
import { toggleClass, off, on } from 'gaspard'
import { constants } from '../../assets/js/utils'
import Cta from '../Cta'

export default {
    model: {
        prop: 'isOpen'
    },
    components: {
        Cta
    },
    props: {
        isOpen: {
            type: Boolean,
            required: true
        },
        closeLabel: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            isSlide: false
        }
    },
    watch: {
        isOpen (value) {
            toggleClass(getHtml(), 'g_scrollLock', value)

            if (value) {
                this.bindEvent()
                setTimeout(() => this.$refs.close.$el.focus(), 500)
            } else {
                this.$emit('focusBack')
                this.unbindEvent()
            }

            this.$emit('change', value)
        }
    },
    beforeDestroy () {
        this.close()
    },
    methods: {
        bindEvent () {
            on(document, 'keyup', this.closeDiscoverEchap)
            on(document, 'click', this.closeDiscoverOverlay)
        },
        unbindEvent () {
            off(document, 'keyup', this.closeDiscoverEchap)
            off(document, 'click', this.closeDiscoverOverlay)
        },
        closeDiscoverEchap (e) {
            const keyCode = e.keyCode || e.which
            if (keyCode === constants.ESC) {
                e.preventDefault()
                this.close()
                return false
            }
        },
        closeDiscoverOverlay (e) {
            const { className } = e.target
            if (['g_popinFixed', 'g_popinOverlay'].indexOf(className) > -1) {
                this.close()
            }
        },
        close () {
            this.unbindEvent()
            this.$emit('input', false)
        },
        slide () {
            if (!this.$breakpoint.isS) {
                return
            }
            this.isSlide = true
        },
        unslide () {
            this.isSlide = false
        }
    }
}
</script>

